/**
 * Firestore caps the `in` / `array-contains-any` operators at 30 values per query.
 *
 * The previous app passed whole garage-id lists straight into `where('garageId','in',…)`,
 * which fails outright once an account holds more garages than the cap. Callers chunk
 * with this and merge the resulting streams.
 */
export const FIRESTORE_IN_LIMIT = 30;

export function chunkForIn<T>(values: readonly T[], size = FIRESTORE_IN_LIMIT): T[][] {
  if (size < 1) {
    throw new Error('chunk size must be at least 1');
  }
  const chunks: T[][] = [];
  for (let i = 0; i < values.length; i += size) {
    chunks.push(values.slice(i, i + size));
  }
  return chunks;
}
